import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import { Title } from '../../components/SignUpV2/Styled';
import Layout from '../../components/Layout';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';

const Spacing = { paddingTop: '0.8em' };

export const RequestEmailChange = ({ i18n }: WithTranslation) => {
    return (
        <Layout>
            <Title style={{ whiteSpace: 'nowrap', paddingBottom: '1em' }}>{i18n.t('requestEmailChange.heading')}</Title>
            <TextStyle as="p">
                {i18n.t('requestEmailChange.verification')}
                <ul>
                    <li style={Spacing}>
                        <Trans i18nKey="requestEmailChange.step1">
                            Step 1: <strong>Confirm email change</strong> on your <strong>old</strong> email address
                        </Trans>
                    </li>
                    <li style={Spacing}>
                        <Trans i18nKey="requestEmailChange.step2">
                            Step 2: <strong>Verify your new email</strong> on your <strong>new</strong> email address
                        </Trans>
                    </li>
                </ul>
            </TextStyle>
        </Layout>
    );
};

export default withTranslation()(RequestEmailChange);
